import { IResearchedAd } from '@/api/research-jobs/ads/get-researched-ads-query'

/**
 * The ad's copy fields in display order, empty ones dropped — shared by the card and the modal.
 * The primary `body` copy comes right after the title so it is what the card previews. The link
 * `caption` (usually just the display domain, e.g. "calm.com") is deliberately excluded — it adds
 * no creative signal.
 */
export function getResearchAdTextContent(ad: IResearchedAd) {
    return getCreativeTextContent(ad.creative)
}

/**
 * The same ordering for any creative level — the ad's, a collation version's, or a card's.
 *
 * Shared rather than duplicated because a card set is exactly where the levels diverge: a DPA's
 * ad-level title is routinely the macro `{{product.short_description}}` while each card carries a
 * real product title, so the modal has to render the SELECTED level's copy and must not drift into
 * a second ordering while doing it.
 */
export function getCreativeTextContent(creative: {
    title: string | null
    body: string | null
    description: string | null
}) {
    return [
        { type: 'title', content: creative.title },
        { type: 'body', content: creative.body },
        { type: 'description', content: creative.description },
    ].filter((item): item is { type: string; content: string } => Boolean(item.content))
}
